export default __webpack_public_path__ + "static/O0267-338817b07299525a41d2d428eb88fe07.png";